import { render } from "./SignatureView.vue?vue&type=template&id=4df4b5ec&ts=true"
import script from "./SignatureView.vue?vue&type=script&lang=ts"
export * from "./SignatureView.vue?vue&type=script&lang=ts"

import "./SignatureView.vue?vue&type=style&index=0&id=4df4b5ec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__